import { unsubscribe } from "pubsub-js";

class SubscriptionTokenCollection {
	private _tokens: PubSubSubscriptionToken[];

	constructor() {
		this._tokens = [];
	}

	public add(token: PubSubSubscriptionToken) {
		this._tokens.push(token);
	}

	public destroy() {
		for (const token of this._tokens) {
			unsubscribe(token);
		}
		this._tokens = [];
	}
}

export {
	SubscriptionTokenCollection
};
